import React, { useState, useEffect } from "react";
import axios from "../../../../axios";
import "../../PopUp/PopUP.css";
import AddClassMaterial from "../buttons/AddClassMaterial";
import JoinNowbtn from "../buttons/JoinNowbtn";
import ViewSummaryBtn from "../buttons/ViewSummaryBtn";
import moment from "moment";
import SummaryUpdated from "../../SummaryUpdated/SummaryUpdated";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import AssessmentViewClickPopup from "../../../../DcmDetails/Summary/SummaryUpdated/AssessmentViewClickPopup";
import StudyPlannerPop from "./StudyPlannerPop";
import { Tooltip } from "@mui/material";
import { shortenParagraph } from "../../../../utils/Engagement";
/**
 * sets how to display day based events on the sj schedule day view component
 * @param {*} param0
 * @returns
 */

// export default function SciencePopUp({ event }) {
const SciencePopUp = ({ event, open1 }) => {

  const [summary, setSummary] = useState(false);
  const [activity, setActivity] = useState([]);
  const [homework, setHomework] = useState([]);
  const [preRead, setPreRead] = useState([]);
  const [assessment, setAssessment] = useState([]);
  const [assClick, setAssClick] = useState(false);
  const [assessmentData, setAssessmentData] = useState(false)


  const navigate = useNavigate();

  const currentTime = new Date();

  // determines if event is after currently happening based on current time
  const isHappened = currentTime.getTime() > event?.EndTime?.getTime();

  // determines if event is currently happening based on current time
  const isEventHappening =
    currentTime.getTime() >= event?.StartTime?.getTime() &&
    currentTime.getTime() <= event?.EndTime?.getTime();

  // determines if event is before currently happening based on current time
  const isUpcoming = currentTime.getTime() < event?.StartTime?.getTime();

  const onJoinNowClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  const timeDiff = (timeStart, timeEnd) => {
    var time1 = timeStart;
    var time2 = timeEnd;
    // Convert the time strings to Date objects
    var date1 = new Date(time1);
    var date2 = new Date(time2);

    // Calculate the difference in milliseconds between the two times
    var diffInMs = date2.getTime() - date1.getTime();

    // Convert the difference in milliseconds to minutes, assuming 1 minute = 60000 ms
    var diffInMins = diffInMs / 60000;
    return diffInMins;
  };

  //Modify the code structure for handle the all promises error
  useEffect(() => {
    const handleSupplementDetails = async () => {
      // Ensure that 'event?.Events' exists and is an array
      if (!event?.Events || !Array.isArray(event.Events)) {
        return;
      }

      for (const obj of event.Events) {

        if (obj.name === "activity") {
          try {
            const res = await axios.get(`/homework/activity/getById/${obj.value}`);
            if (res && res.data && res.data.data) {
              setActivity(res.data.data);
            }
          } catch (error) {
            setAssessmentData(error.response.data.message)
            console.error("Error fetching activity:", error);
          }
        }

        if (obj.name === "pre_read") {
          try {
            const res = await axios.get(`/homework/preRead/getById/${obj.value}`);
            if (res && res.data && res.data.data) {
              setPreRead(res.data.data);
            }
          } catch (error) {
            setAssessmentData(error.response.data.message)
            console.error("Error fetching pre-read:", error);
          }
        }

        if (obj.name === "assessment") {
          try {
            const res = await axios.get(`/assessment/getForStudent/${obj?.value}`);
            if (res && res.data && res.data.data) {
              setAssessment(res.data.data);
            }
          } catch (error) {
            setAssessmentData(error.response.data.message)
            console.error("Error fetching assessment:", error);
          }
        }

        if (obj.name === "homework") {
          try {
            const res = await axios.get(`/homework/get/${obj.value}`);
            if (res && res.data && res.data.data) {
              setHomework(res.data.data);
            }
          } catch (error) {
            setAssessmentData(error.response.data.message)
            console.error("Error fetching homework:", error);
          }
        }
      }
    };
    handleSupplementDetails();
  }, [event]);

  const currentUser = useSelector((state) => state.user.currentUser);

  const [status, setStatus] = useState({
    assessment: "",
    preRead: "",
    activity: "",
    homework: "",
  });

  // console.log("assessmentkuldeep", assessment)
  useEffect(() => {
    const fetchData = async () => {
      try {

        const resources = [
          {
            type: "assessment",
            id: assessment?.id,
            setStatusKey: "assessment",
          },
          {
            type: "preRead",
            id: preRead?.id,
            setStatusKey: "preRead",
          },
          {
            type: "activity",
            id: activity?.id,
            setStatusKey: "activity",
          },
          {
            type: "homework",
            id: homework?.id,
            setStatusKey: "homework",
          },
        ];

        for (const resource of resources) {
          if (resource.id) {
            const response = await axios.get(
              `/${resource.type}/studentStatus/${resource.type}Id/${resource.id}/studentId/${currentUser?.id}`
            );
            setStatus((prevStatuses) => ({
              ...prevStatuses,
              [resource.setStatusKey]: response.data.data.status,
            }));
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }

      console.log(status);
    };

    fetchData();
  }, [assessment, homework, activity, preRead, currentUser]);



  //assessment function to return based on status
  function getRRoutefromStatus(status, assessmentId) {
    let url;
    switch (status) {
      case "completed":
        url = `/Assessment/completed`;
        break;
      case "pending":
        // url = `/Assessment/pending/questions/${assessmentId}`;
        setAssClick(true);
        return;
      case "review":
        url = `/Assessment/review/questions`;
        break;
      default:
        url = "/Calender";
    }
    navigate(url, { state: { assessmentId: assessmentId } });
    return;
  }

  function getRRoutefromStatusPreRead(status, id) {
    let url;
    switch (status) {
      case "completed":
        url = `/presRead/completed`;
        break;
      case "pending":
        url = `/preReads/published`;
        break;
      default:
        url = "/Calender";
        break;
    }
    navigate(url, { state: { preReadId: id } });
    return;
  }

  function getRRoutefromStatusActivity(status, id) {
    let url;
    switch (status) {
      case "completed":
        url = `/completedActivity`;
        break;
      case "pending":
        url = `/publishedActivity`;
        break;
      case "review":
        url = `/reviewActivity`;
        break;
      default:
        url = "/Calender";
        break;
    }
    navigate(url, { state: { activityId: id } });
    return;
  }

  function getRRoutefromStatusHomework(status, id) {
    let url;
    switch (status) {
      case "completed":
        url = `/completedHomework`;
        break;
      case "pending":
        url = `/publishedhomework`;
        break;
      case "review":
        url = `/reviewHomework`;
        break;
      default:
        url = "/Calender";
        break;
    }
    navigate(url, { state: { homeworkId: id } });
    return;
  }

  // console.log(moment(event.StartTime).format("ddd, hA"))
  return event ? (
    <>
      <div onClick={onJoinNowClick}>
        <div className="headingPoPUP">
          <div>
            <div className="sub_pop_head">
              {(isHappened && event.Events[0] === "Planner") && "Study Planner"}
              {(isHappened && event.Events[0] !== "Planner") && "Previous Session"}
              {(isEventHappening) && event.Events[0] !== "Planner" && "Lecture Session"}
              {isUpcoming && event.Events[0] === "Planner" && "Study Planner"}
              {isUpcoming && event.Events[0] !== "Planner" && "Lecture Session"}
            </div>
            {console.log("event", event)}
            <div className="sub_pop_head">{
              <Tooltip
                title={event?.Subject}
                arrow
                placement="bottom"
                enterDelay={200}
                leaveDelay={100}
              >
                <div>
                  {shortenParagraph(event?.Subject || "", 15)}
                </div>
              </Tooltip>
            }</div>
            <div className="sub_pop_Subhead">{
              <Tooltip
                title={event?.Teacher?.name}
                arrow
                placement="bottom"
                enterDelay={200}
                leaveDelay={100}
              >
                <div>
                  {shortenParagraph(event?.Teacher?.name || "", 15)}
                </div>
              </Tooltip>
            }</div>
            <div className="sub_pop_Subhead">{
              <Tooltip
                title={event?.name || ""}
                arrow
                placement="bottom"
                enterDelay={200}
                leaveDelay={100}
              >
                <div>
                  {shortenParagraph(event?.name || "", 15)}
                </div>
              </Tooltip>
            }</div>
            <div className="sub_pop_Subhead">{
              <Tooltip
                title={event?.description}
                arrow
                placement="bottom"
                enterDelay={200}
                leaveDelay={100}
              >
                <div>
                  {shortenParagraph(event?.description || "", 20)}
                </div>
              </Tooltip>
            }</div>
          </div>
          <div>
            <div className="sub_pop_head">
              {moment(event?.StartTime).format(" Do MMM YY , dddd")}
            </div>
            <div className="sub_pop_head">
              {moment(event?.StartTime).format(" h:mm A")}&nbsp;-{" "}
              {moment(event?.EndTime).format(" h:mm A")}
            </div>
            {/* <div className='sub_pop_head' >{moment(event.EndTime).format(" h:mm a")}</div> */}
            <div className="sub_pop_Subhead">
              {timeDiff(event?.StartTime, event?.EndTime)}min
            </div>
          </div>
        </div>
        <div class="bg-white">
          <div className="btm">
            {event.Events.some((item) => item.name === "assessment") && (
              <div className="headingPoPUP_detail">
                <div className="col-4">
                  {/* <Link to={`/Assessment/pending/questions/${assessment?.id}`}> */}
                  <img
                    className="popIcon mb-2"
                    alt=""
                    src="/DCM-img/assessment.svg"
                    onClick={() => {
                      localStorage.setItem("from", 'DCM');
                      getRRoutefromStatus(
                        status.assessment,
                        assessment?.id
                      )
                    }
                    }
                  ></img>
                  {/* </Link> */}
                  <div className="icon_pop_title">Assessment</div>
                </div>
                <div>
                  <div className="sub_pop_head">
                    {assessment?.name && (
                      <Tooltip
                        title={assessment.name}
                        arrow
                        placement="bottom"
                        enterDelay={200}
                        leaveDelay={100}
                      >
                        <div>
                          {shortenParagraph(assessment.name, 25)}
                        </div>
                      </Tooltip>
                    )}
                  </div>
                  <div>
                    {assessment?.description && (
                      <Tooltip
                        title={assessment.description}
                        arrow
                        placement="bottom"
                        enterDelay={200}
                        leaveDelay={100}
                      >
                        <div>
                          {shortenParagraph(assessment.description, 40)}
                        </div>
                      </Tooltip>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div class=" card-header_new bg-white">
          <div class="row btm">
            {event.Events.some((item) => item.name === "pre_read") && (
              <div className="headingPoPUP_detail">
                <div className="col-4">
                  {/* <Link to={`/preReads/published/${preRead?.id}`}> */}
                  <img
                    className="popIcon mb-2"
                    src="/DCM-img/preread.svg"
                    alt=""
                    onClick={() => {
                      getRRoutefromStatusPreRead(
                        status.preRead,
                        preRead?.id
                      );
                    }}
                  ></img>
                  {/* </Link> */}
                  <div className="icon_pop_title_preRead">Pre-read</div>
                </div>
                <div>
                  <div className="sub_pop_head">{
                    <Tooltip
                      title={preRead?.name}
                      arrow
                      placement="bottom"
                      enterDelay={200}
                      leaveDelay={100}
                    >
                      <div>
                        {shortenParagraph(preRead?.name, 25)}
                      </div>
                    </Tooltip>
                  }</div>
                  <div>{
                    <Tooltip
                      title={preRead?.description}
                      arrow
                      placement="bottom"
                      enterDelay={200}
                      leaveDelay={100}
                    >
                      <div>
                        {shortenParagraph(preRead?.description, 40)}
                      </div>
                    </Tooltip>
                  }</div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div class=" card-header_new bg-white">
          <div class="row btm">
            {event.Events.some((item) => item.name === "activity") && (
              <div className="headingPoPUP_detail">
                <div className="col-4">
                  {/* <Link to={`/publishedActivity/${activity?.id}`}> */}
                  <img
                    className="popIcon mb-2"
                    src="/DCM-img/activity.svg"
                    alt=""
                    onClick={() => {
                      getRRoutefromStatusActivity(
                        status.activity,
                        activity?.id
                      );
                    }}
                  ></img>
                  {/* </Link> */}
                  <div className="icon_pop_title_activity">Activity</div>
                </div>
                <div>
                  <div className="sub_pop_head">{
                    <Tooltip
                      title={activity?.name}
                      arrow
                      placement="bottom"
                      enterDelay={200}
                      leaveDelay={100}
                    >
                      <div>
                        {shortenParagraph(activity?.name, 25)}
                      </div>
                    </Tooltip>
                  }</div>
                  <div>{
                    <Tooltip
                      title={activity?.description}
                      arrow
                      placement="bottom"
                      enterDelay={200}
                      leaveDelay={100}
                    >
                      <div>
                        {shortenParagraph(activity?.description, 40)}
                      </div>
                    </Tooltip>
                  }</div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div class=" card-header_new bg-white">
          <div class="row btm">
            {event.Events.some((item) => item.name === "homework") && (
              <div className="headingPoPUP_detail">
                <div className="col-4">
                  {/* <Link to={`/publishedHomework/${homework?.id}`}> */}
                  <img
                    className="popIcon mb-2"
                    src="/DCM-img/homework.svg"
                    alt=""
                    onClick={() =>
                      getRRoutefromStatusHomework(
                        status.homework,
                        homework?.id
                      )
                    }
                  ></img>
                  {/* </Link> */}
                  <div className="icon_pop_title">Homework</div>
                </div>
                <div>
                  <div className="sub_pop_head">{
                    <Tooltip
                      title={homework?.name}
                      arrow
                      placement="bottom"
                      enterDelay={200}
                      leaveDelay={100}
                    >
                      <div>
                        {shortenParagraph(homework?.name, 25)}
                      </div>
                    </Tooltip>
                  }</div>
                  <div>{
                    <Tooltip
                      title={homework?.description}
                      arrow
                      placement="bottom"
                      enterDelay={200}
                      leaveDelay={100}
                    >
                      <div>
                        {shortenParagraph(homework?.description, 40)}
                      </div>
                    </Tooltip>
                  }</div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div>
          {/* Hide the view summary button  and update logic*/}
          {(isHappened && event.Events[0] !== "Planner") && event?.SupplementId === undefined ? "" : isUpcoming && event?.SupplementId === undefined ? "" : (isHappened && event.Events[0] === "Planner") && event?.SupplementId === undefined ? "" : <ViewSummaryBtn event={event} setSummary1={setSummary} />}
          {summary && <SummaryUpdated assessmentId={assessment?.id} CloseSummaryShowToday={() => { setSummary(false) }} data={event} open={() => { open1() }} />}
          {isEventHappening &&
            event.Events.some((item) => item.name === "bbb_lecture") && (
              <JoinNowbtn event={event} />
            )}
          {isUpcoming && <AddClassMaterial event={event} />}
          {assClick && <AssessmentViewClickPopup setAssClick={setAssClick} />}
          {assessmentData && <StudyPlannerPop assessmentData={assessmentData} setAssessmentData={setAssessmentData} />}
        </div>
      </div >
    </>
  ) : (
    <></>
  );
};
export default SciencePopUp;
